"use strict";

angular.module("dokiv")
  .factory("reloadUserRoleDashboard", ["$timeout", "$state", function($timeout, $state) {
    var reloadDashboard = {};
    var r;
    reloadDashboard.reload = function() {
      if(r) {
        $timeout.cancel(r);
        r = null;
      }
      r = $timeout(function(){
        $state.reload();
      }, 300000);
    };

    reloadDashboard.stop = function() {
      $timeout.cancel(r);
      r = null;
    };
    return reloadDashboard;
  }]);


//////////////////
// WEBPACK FOOTER
// ./scripts/app/ReloadUserRoleDashboard.js
// module id = 52
// module chunks = 0